export class GalleryContentStyle {
  size = 'uk-h5';
  font = 'tb-font-primary';
  marginTop = 'uk-margin-remove-top';
  dropCap = '';
  transition = '';

  static normalize(styles: Partial<GalleryContentStyle>): GalleryContentStyle {
    const pureStyles = new GalleryContentStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.dropCap = styles.dropCap ?? pureStyles.dropCap;
    pureStyles.transition = styles.transition ?? pureStyles.transition;

    return pureStyles;
  }
}
